import { render, staticRenderFns } from "./DiscoveryExpertView.vue?vue&type=template&id=4c507504&scoped=true"
import script from "./DiscoveryExpertView.vue?vue&type=script&lang=js"
export * from "./DiscoveryExpertView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c507504",
  null
  
)

export default component.exports